module.exports = __webpack_public_path__ + "img/PL08351.137b5f96.png";